import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { FormType } from '../state-man/models/form-type.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class FormTypeService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  public async getAll () : Promise<FormType[] | null> {      
    try {
      const ret = await this.apiService.apiReturnsAny('get', 'form_type/')        
      return (ret && Array.isArray(ret)) ? FormType.buildMany(ret) : null
    } catch (error) {   
      LoggerService.log(error + 'form_type/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')     
      return null
    }
  }  
  
}
